import React from "react";

function Sidebar({
  currentView,
  setCurrentView,
  sidebarOpen,
  setSidebarOpen,
}) {

  return (

    <div
      className={
        sidebarOpen
          ? "sidebar open"
          : "sidebar closed"
      }
    >

      {/* TOP */}

      <div className="sidebar-top">

        <button
          className="toggle-btn"
          onClick={() =>
            setSidebarOpen(!sidebarOpen)
          }
        >
          ☰
        </button>

      </div>

      {/* HOME */}

      <button
        data-tooltip="Home"
        className={
          currentView === "home"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("home")
        }
      >
        {sidebarOpen ? "🏠 Home" : "🏠"}
      </button>

      {/* KPI */}

      <button
        data-tooltip="KPI Cards"
        className={
          currentView === "kpi"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("kpi")
        }
      >
        {sidebarOpen
          ? "📊 KPI Cards"
          : "📊"}
      </button>

      {/* TODAY PRICE */}

      <button
        data-tooltip="Today Price"
        className={
          currentView === "todayprice"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("todayprice")
        }
      >
        {sidebarOpen
          ? "💰 Today Price"
          : "💰"}
      </button>

      {/* CATEGORIES */}

      <button
        data-tooltip="Categories"
        className={
          currentView === "categories"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("categories")
        }
      >
        {sidebarOpen
          ? "📦 Categories"
          : "📦"}
      </button>

      {/* HISTORICAL */}

      <button
        data-tooltip="Historical Price"
        className={
          currentView === "history"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("history")
        }
      >
        {sidebarOpen
          ? "📈 Historical Price"
          : "📈"}
      </button>

      {/* AI */}

      <button
        data-tooltip="AI Assistant"
        className={
          currentView === "ai"
            ? "active-btn"
            : ""
        }
        onClick={() =>
          setCurrentView("ai")
        }
      >
        {sidebarOpen
          ? "🤖 AI Assistant"
          : "🤖"}
      </button>

    </div>
  );
}

export default Sidebar;